import { render } from "./quranPrograms.vue?vue&type=template&id=0445bc70&scoped=true"
import script from "./quranPrograms.vue?vue&type=script&lang=js"
export * from "./quranPrograms.vue?vue&type=script&lang=js"

import "./quranPrograms.vue?vue&type=style&index=0&id=0445bc70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0445bc70"]])

export default __exports__